<template>
  <!-- Manage Board Modal -->
  <BaseModal
    no-padding
    @close="$emit('close')"
  >
    <template #toolbar>
      <div class="text-black w-full flex flex-col items-center font-medium justify-center">
        <span class="text-xl">Update your Payment Method</span>
      </div>
    </template>

    <template #default>
      <div class="p-4">
        <!-- Divider -->
        <div class="border p-2 rounded-md">
          <StripeElements
            #default="{ elements }"
            ref="cardElms"
            :stripe-key="stripeKey"
            :instance-options="instanceOptions"
            :elements-options="elementsOptions"
          >
            <StripeElement
              ref="card"
              type="card"
              :elements="elements"
              :options="cardOptions"
            />
          </StripeElements>
        </div>

        <div class="flex justify-end">
          <div
            class="pt-3 text-right"
          >
            <button
              class="base-btn"
              :disabled="loadingPaymentUpdate || loadingIntent"
              @click="updatePaymentMethod"
            >
              <BaseText
                v-if="!loadingPaymentUpdate"
                size="sm"
                class="text-text-muted"
              >
                Update Payment
              </BaseText>
              <BaseLoadingSpinnerCircle v-else />
            </button>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus'
import { mapGetters } from 'vuex'
import ForeplayAPI from '@/api/foreplayServer'

export default {
  name: 'UpdatePaymentMethodModal',
  components: {
    StripeElements,
    StripeElement
  },
  props: {
  },
  data () {
    return {
      stripeKey: 'pk_live_51JS7DeAQtq0TW7KZxoGv8Spu6IJhR335IoLxdfBQMF8VCbWJFDrUl2DfeNJllyC79mZJv8kX0qiaNGFCgbrTznpA00kPK2gMwN',
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
      },
      cardOptions: {
        style: {
          base: {
            fontSize: '1.2rem'
          }
        }
      },
      loadingPaymentUpdate: false,
      loadingIntent: false,
      clientSecret: null
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUserSubscription', 'getStripeCustomer', 'getUser'])
  },
  async mounted () {
    await this.initStripeIntent()
  },
  methods: {
    async initStripeIntent () {
      this.loadingIntent = true
      try {
        const { setupIntent } = await ForeplayAPI.Subscription.createSetupIntent()
        this.clientSecret = setupIntent.client_secret
      } catch (error) {
        this.$showAlert({
          type: 'error',
          message: 'Failed to initialize payment form.'
        })
        this.$emit('close')
      } finally {
        this.loadingIntent = false
      }
    },
    async updatePaymentMethod () {
      if (this.loadingPaymentUpdate) return
      this.loadingPaymentUpdate = true
      try {
        // ref in template
        const groupComponent = this.$refs.cardElms
        const cardElement = groupComponent.elements.getElement('card')

        // Make an api call to create a payment intent using the current setup intent
        const stripe = groupComponent.instance

        const { setupIntent, error } = await stripe.confirmCardSetup(this.clientSecret, {
          payment_method: { card: cardElement }
        })

        if (error) {
          return this.$showAlert({
            message: 'Failed to update payment method. If you think this is an error, please contact support.',
            type: 'error'
          })
        }

        await ForeplayAPI.Subscription.updatePaymentMethod(
          setupIntent.payment_method,
          this.getStripeCustomer.stripeId
        )

        this.$showAlert({
          message: 'Your payment method has been updated.',
          type: 'success'
        })
        this.$emit('close')
      } catch (error) {
        await this.initStripeIntent()
        console.log(error)
        const errorMessage = error.response?.data?.message || 'Failed to update payment method. If you think this is an error, please contact support.'
        this.$showAlert({
          message: errorMessage,
          type: 'error'
        })
      } finally {
        this.loadingPaymentUpdate = false
      }
    }
  }
}
</script>

<style scoped>
.base-btn {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13),
    0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
  border-radius: 6px;
  padding: 6px 8px 6px 8px;
}

.base-btn:hover {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.17),
    0px 0px 0px 1px rgba(0, 56, 108, 0.12);
}

.base-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
